import React from 'react'
import styles from './styles'

const PlayAudio = ({
  isPlay,
  playButton,
  pauseButton,
  minusTimeButton,
  addTimeButton,
  plusVolumeButton,
  minusVolumeButton
}) => (
  <div className="wrapper-controls">
    {minusVolumeButton}
    {minusTimeButton}
    <div>{isPlay ? pauseButton : playButton}</div>
    {addTimeButton}
    {plusVolumeButton}
    <style jsx>{styles}</style>
  </div>
)

export default PlayAudio
